"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CbaStepDefinitions = void 0;
var _react = _interopRequireDefault(require("react"));
var _defaultStepDefinitions = require("../../../defaults/quoteTools/defaultStepDefinitions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CbaStepDefinitions = exports.CbaStepDefinitions = [_objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[0]), {}, {
  actionButtonsBar: _defaultStepDefinitions.DefaultStepDefinitions[0].actionButtonsBar
}), _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[1]), {}, {
  label: 'Cover options',
  actionButtonsBar: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[1].actionButtonsBar), {}, {
    secondary: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[1].actionButtonsBar.secondary), {}, {
      containerType: function containerType(isMobile) {
        return isMobile ? 'column' : 'row';
      }
    })
  })
}), _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[2]), {}, {
  label: 'Your details',
  actionButtonsBar: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[2].actionButtonsBar), {}, {
    secondary: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[2].actionButtonsBar.secondary), {}, {
      containerType: function containerType(isMobile) {
        return isMobile ? 'column' : 'row';
      }
    })
  })
}), _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[3]), {}, {
  label: 'Summary',
  actionButtonsBar: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[3].actionButtonsBar), {}, {
    secondary: _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[3].actionButtonsBar.secondary), {}, {
      containerType: function containerType(isMobile) {
        return isMobile ? 'column' : 'row';
      }
    })
  })
}), _objectSpread(_objectSpread({}, _defaultStepDefinitions.DefaultStepDefinitions[4]), {}, {
  label: 'Payment'
})];